import { useSetRecoilState } from "recoil";
import formInfoAtom from "./atom";

const useFormInfoDispatch = () => useSetRecoilState(formInfoAtom);
export default useFormInfoDispatch;
